import {
  createRouter,
  createWebHistory
} from 'vue-router';

export default createRouter({
  history: createWebHistory('/'),
  routes: [{
    name: 'main',
    path: '/',
    component: () => import('@/components/Page.vue'),
  }, {
    name: 'category',
    path: '/:id',
    component: () => import('@/components/Page.vue'),
  }],
});
